import ProductServ from "../service/ProductServ";

// Extract number from measurement (e.g. "2kg" -> 2)
export const getMeasurementNum = (val) => {
    if (!val) return null;
    const match = String(val).match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : null;
};

// Helper: Recalculate Pricing for Options
// Keeps the 20% discount rule and backend math exact.
export const recalculateOptionsPricing = (options) => {
    if (!options || !Array.isArray(options)) return { newOptions: options, updated: false };
    const newOptions = JSON.parse(JSON.stringify(options));
    let updated = false;

    newOptions.forEach((group) => {
        if (group?.autoCalculate && group?.variants && group?.variants?.length > 0) {
            const base = group.variants[0];
            if (!base) return;

            const baseMrp = parseFloat(base.mrp) || 0;
            const basePrice = parseFloat(base.price) || 0;
            const baseStock = parseInt(base.stock) || 0;
            const baseVal = getMeasurementNum(base.value);

            // Backend Rule: Price <= MRP * 0.8 (At least 20% lower)
            let baseDiscount = baseMrp > 0 ? Math.round(((baseMrp - basePrice) / baseMrp) * 100) : 0;
            if (baseDiscount < 20) baseDiscount = 20;

            group.variants.forEach((v, vIdx) => {
                if (!v) return;

                const curMrp = parseFloat(v.mrp) || 0;
                const curPrice = parseFloat(v.price) || 0;
                const maxAllowed = Math.floor(curMrp * 0.8);

                if (vIdx > 0) {
                    const curVal = getMeasurementNum(v.value);
                    if (baseVal && curVal && baseVal > 0) {
                        const ratio = curVal / baseVal;
                        v.mrp = Math.round(baseMrp * ratio);
                        v.stock = baseStock;
                    }

                    const targetPrice = Math.round(v.mrp * (1 - baseDiscount / 100));
                    v.price = Math.min(targetPrice, Math.floor(v.mrp * 0.8));
                    v.discount = baseDiscount;
                    updated = true;
                } else {
                    // Base row validation
                    if (v.discount !== baseDiscount) {
                        v.discount = baseDiscount;
                        updated = true;
                    }
                    if (curPrice > maxAllowed) {
                        v.price = maxAllowed;
                        v.discount = 20;
                        updated = true;
                    }
                }
            });
        } else if (group?.variants) {
            // Manual calculation sync
            group.variants.forEach(v => {
                if (!v) return;
                const mrp = parseFloat(v.mrp) || 0;
                const price = parseFloat(v.price) || 0;
                const discount = mrp > 0 ? Math.round(((mrp - price) / mrp) * 100) : 0;
                if (v.discount !== discount) {
                    v.discount = discount;
                    updated = true;
                }
            });
        }
    });
    return { newOptions, updated };
};

export const handleVariantImageUpload = async (file) => {
    try {
        const formData = new FormData();
        formData.append("image", file);
        const res = await ProductServ.uploadImage(formData);
        return res.data?.imageUrl || res.imageUrl || res.data?.url || res.url;
    } catch (err) {
        console.error("Variant image upload failed", err);
        throw err;
    }
};
